import text from "../text";
export const uiRender = async (arg) => {
    const { schema } = arg;
    text.ui({ ...arg, value: schema.appRender.options.find((option) => option.selected)?.label || '' });
};
//# sourceMappingURL=uiRender.js.map